import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageUpcomingRequest } from './get-collection-triage-upcoming-request';
import type { IGetCollectionTriageUpcomingResponse } from './get-collection-triage-upcoming-response';
import { getCollectionTriageUpcomingResponseSchema } from './get-collection-triage-upcoming-response';

export async function getCollectionTriageUpcomingApi({
  collectionId,
  limit = 3,
}: IGetCollectionTriageUpcomingRequest): Promise<
  IValidatedResponse<IGetCollectionTriageUpcomingResponse>
> {
  return getRequest<IGetCollectionTriageUpcomingResponse>({
    path: `/sys/collections/${collectionId}/triage/upcoming?limit=${limit}`,
    schema: getCollectionTriageUpcomingResponseSchema,
  });
}
